import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col, Popover} from 'antd';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import help from '../../config/help.json';
import { QuestionCircleOutlined,DownloadOutlined } from '@ant-design/icons';
import { CSVLink } from 'react-csv';


import './analytics.css';


var cc_data;
var contentlist;

class Top10SeriesTitle extends Component {
	constructor(props) {
		super(props);
		this.state = {
		 }
	}

	async componentDidUpdate(prevProps) {
	}



	render() {
		const { opensearchTop10SeriesTitleList, opensearchSeriesList } = this.props;

		cc_data = opensearchTop10SeriesTitleList || [];
		contentlist = opensearchSeriesList || [];
		let poster = require('../../../src/static/no_image.jpg');
		let tvseries,tvseason = '';

		function getPoster(contentId){
			tvseries = contentlist.find(d=> d._source.metadata[0].title === contentId && d._source.contentType === 'tvseries');
			if(tvseries && tvseries._source && tvseries._source.contentId){
				tvseason = contentlist.find(d=> d._source.tvseriesId === tvseries._source.contentId && d._source.contentType === 'tvseasons');
			}
			if(tvseason && tvseason._source && tvseason._source.imageLandscape){
				poster =  tvseason._source.imageLandscape;
			}	
			return poster;
		};
		const settings = {
			focusOnSelect: true,
			infinite: false,
			variableWidth: true,
			slidesToScroll: 1,
			speed: 500,
		  };
		// function getDetails(contentId){
		// 	tvseries = contentlist.find(d=> d._source.metadata[0].title == contentId && d._source.contentType == 'tvseries');
		// 	if(tvseries && tvseries._source && tvseries._source.contentId){
		// 		tvseason = contentlist.find(d=> d._source.tvseriesId == tvseries._source.contentId && d._source.contentType == 'tvseasons');
		// 	}
		// 	if(tvseason && tvseason._source && tvseason._source.imageLandscape){
		// 		poster =  tvseason._source.imageLandscape;
		// 	}	
		// 	return <div>
		// 			<p>Title : {contentId}</p>
		// 			<img src = {poster} width={140}/>
		// 			</div>;
		// }
		// const columns = [
		// 	{
		// 	  title: 'TVSeries Title',
		// 	  dataIndex: 'key',
		// 	  render: (text) => (
		// 		<>
		// 		  <Popover
		// 			placement="topLeft"
		// 			//title={text}
		// 			content={getDetails(text)}
		// 			trigger="click"
		// 		  >
		// 			<a>{text}</a>
		// 		  </Popover>
		// 		</>
		// 	  )
		// 	},
		// 	{
		// 	  title: 'Count',
		// 	  dataIndex: 'doc_count',
			  
		// 	}
		//   ];
		

		return (
      <Card className="analyticCard portraitPoster">
				<h3 className="title">{`Most Searched TV Series  `}
				<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='Top10SeriesTitle').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={cc_data.map((c,k) => ({ items: k+1 , content_title: c.key , count:c.doc_count}))} target="_blank" filename={"Most Searched TV Series.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
				 <Col span={24}>
				 	{/* <Table style={{ height: 400, width: '100%' }} theme={userTheme} dataSource={cc_data} columns={columns} pagination={{pageSize:5}} /> */}
					 <Slider   {...settings}>
							{
								cc_data.map((d, k) =>(
									<div key= 'poster' className='portaitPoster'>
										<div key='image' className='portaitPoster image'><img alt="" src={getPoster(d.key)}  style={{width:'100%' }}></img></div>
										<div key='title' className='portaitPoster detail'><p className="portaitPoster title">#{k+1}  {d.key}</p></div>
										<div key='views' className='portaitPoster detail'><p className="portaitPoster view">{d.doc_count} views</p></div>
									</div>
									)
									
								)
							}
						
						</Slider>
				</Col>
 				</Row>
     </Card>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
	opensearchTop10SeriesTitleList: state.search.opensearchTop10SeriesTitleList,
	opensearchSeriesList : state.analytics.opensearchSeriesList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Top10SeriesTitle));
